module.exports = __webpack_public_path__ + "img/gamelog.7ca89da6.png";